import React from 'react';

function stringSanitizer(string) {
  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[ -]+/g, '-');
}

export default stringSanitizer;
